
import LoginService from '../api/login.service';
import AccessRightsService from '../api/access-rights.service';
import CacheUtilities from '../cache/CacheUtilities';
import ThemeService from '../api/theme.service';
import ProviderService from '../api/provider.service';
import StorageService from '../session/storage.service';
import SettingsService from '../api/settings.service';
import StorageType from '../session/storage.enum';
import toast from 'react-hot-toast';



const handleNavigation = (loginResponse, navigate) => {
  if (loginResponse.changePassword === true) {
    navigate('/change-password');
  }
  if (loginResponse.userType === 1) {
    navigate('/provider');
  } else if (loginResponse.userType === 2) {
    navigate('/admin');
  }
  else {
    navigate('/patient')
  }
};

const login = (loginData) => {
  return LoginService.login(loginData);
};
const onLoginSuccess = async (data,navigate, contextDispatch, setLogo, setIsLoggingIn) => {
  let loginResponse = data.apiResponse;
  StorageService.setFirstLoginCount();
  //console.log(JSON.stringify(data))
  if (loginResponse.userType == 0) {
    toast.success("It looks like you are a patient. Please hold while we redirect you to the correct Login.")
    setTimeout(() => {
      window.location.assign('https://login.revique.io/#/login')
    }, 15000)
  } else {
    if (loginResponse['termsConditions'] === false) {
      StorageService.save('session', 'auth', JSON.stringify(loginResponse));
      return navigate(`/terms-conditions/${loginResponse.id}`);
    } else if (loginResponse['changePassword'] === true) {
      StorageService.save('session', 'auth', JSON.stringify(loginResponse));
      return navigate(`/change-password/${loginResponse.parentId}/${loginResponse.userType}/${loginResponse.id}/${loginResponse.changePassword}/${data.providerName != undefined ? data.providerName : ''}`);
    } else {
      StorageService.save('session', 'auth', JSON.stringify(loginResponse));

      if (loginResponse.userType == 1) {
        let userDataResponse;
        let providerSettings;

        LoginService.getloginUserDetail(loginResponse['userType'], data['userName'], loginResponse['parentId'])
          .then(async (result) => {
            //console.log(JSON.stringify(result))
            contextDispatch({ type: 'setProviderSelected', payload: result });
            StorageService.save('session', "userDetails", JSON.stringify(result));
            let permissions = AccessRightsService.getModuleDetails(result);
            contextDispatch({ type: 'setPermissions', payload: permissions });
            userDataResponse = result;

            ProviderService.getProviderDetails(loginResponse.parentId)
              .then(async (result) => {
                //console.log(JSON.stringify(result))
                let details = result;
                StorageService.save('session', 'providerSelected', JSON.stringify(result));
                contextDispatch({ type: 'setSettingsData', payload: result });
                setLogo && setLogo(details.logo);
                providerSettings = {
                  logo: details.logo,
                  skin: details.skin,
                  providerName: details.providerUrlSuffix,
                  practiceLocationDetails: details.practiceLocation
                };
                StorageService.save('session', "settingsData", JSON.stringify(providerSettings));

                await CacheUtilities.pullAndCachePracticeAndLocationData(details.practiceLocation[0].practiceLocationId, contextDispatch);

                SettingsService.getProviderSettingsSkin(details.providerUrlSuffix)
                  .then(res => {
                    ThemeService.changeTheme(res.data.skin);
                  });
                setLogo && setLogo(providerSettings.logo);
                contextDispatch({ type: 'setSkin', payload: providerSettings });
                setIsLoggingIn && setIsLoggingIn(false);
                handleNavigation(loginResponse, navigate);
              })
              .catch(err => {
                console.log(err);
                setIsLoggingIn && setIsLoggingIn(false);
              })
          })
          .catch(err => {
            console.log(err);
            setIsLoggingIn && setIsLoggingIn(false);
          })
      } else {
        LoginService.getloginUserData(loginResponse['userType'], data['userName'], loginResponse['id'])
          .then((userDataResponse) => {
            StorageService.save('session', 'userDetails', JSON.stringify(userDataResponse.data));
            let permissions = AccessRightsService.setAllFeatureAccessToUser();
            contextDispatch({ type: 'setPermissions', payload: permissions });
            setIsLoggingIn && setIsLoggingIn(false);
            handleNavigation(loginResponse, navigate);
          })
          .catch(error => {
            console.log(error);
            setIsLoggingIn && setIsLoggingIn(false);
          })
      }
    }
  }
}

export { onLoginSuccess, login, handleNavigation };